import { cloneElement } from 'react';
import { useSubstitutionFlowProductHOC } from './hooks';
import makeClasses from './SubstitutionFlowProductHOC.style';
import type { ReactElement, ReactNode } from 'react';
import type { OrderId, ProductId } from 'shared/domain';
import { SFReplacementOptions } from './components';

export function SubstitutionFlowProductHOC(props: Props) {
  const { orderId, orderProductId, children } = props;

  const {
    showReplacementOptions,
    replacementItems,
    stockoutItem,
    isReplacementRemovable,
  } = useSubstitutionFlowProductHOC({ orderId, orderProductId });

  const _classes = makeClasses();

  const showStockoutProductChip = !!stockoutItem;
  if (!showStockoutProductChip) return children;
  return (
    <section className={_classes.sectionWrapper}>
      <article
        className={_classes.article}
        aria-label='substitution-flow-product-hoc'
        data-has-replacement={showReplacementOptions}
        data-order-product-id={stockoutItem.orderProductId}
      >
        <section
          aria-label='stockout-product'
          className={_classes.stockoutSection}
          data-has-replacement={showStockoutProductChip}
          data-product-id={stockoutItem.productId}
        >
          {cloneElement(children as ReactElement, {
            showStockoutProductChip,
            isReplacementRemovable,
          })}
        </section>
        {showReplacementOptions && (
          <SFReplacementOptions replacementItems={replacementItems} />
        )}
      </article>
      <div className={_classes.divider} />
    </section>
  );
}

interface Props {
  orderId: OrderId;
  orderProductId: ProductId;
  children: ReactNode;
}
